import { Trans, useTranslation } from 'react-i18next';
import { Grid2, Typography } from '@mui/material';
import { OrganizationSeatAllocation } from 'features/organizations/organizations.types';

type PurchaseSummaryKey = keyof OrganizationSeatAllocation;
type OrganizationSeatSummaryProps = {
  seats?: OrganizationSeatAllocation;
  showUsed?: boolean;
};

export const OrganizationSeatsSummary = (
  props: OrganizationSeatSummaryProps,
): JSX.Element | null => {
  const { seats, showUsed = false } = props;
  const { t } = useTranslation();

  const summaryKeys: PurchaseSummaryKey[] = ['regular', 'pro'];

  if (!seats) {
    return null;
  }

  const totals = summaryKeys.reduce(
    (acc, key) => {
      acc.purchased += seats[key].purchased;
      acc.used += seats[key].used;
      return acc;
    },
    { purchased: 0, used: 0 },
  );

  return (
    <Grid2 container direction="column" spacing={1}>
      {summaryKeys.map((key) => (
        <Grid2 container key={key} justifyContent="space-between">
          <Typography>
            <b>{t(`organizationSeatsSummary.${key}`)}</b>
          </Typography>
          <Typography>
            {showUsed ? (
              <Trans
                i18nKey="organizationSeatsSummary.seatsTaken"
                values={seats[key]}
              />
            ) : (
              seats[key].purchased
            )}
          </Typography>
        </Grid2>
      ))}
      {showUsed && (
        <Grid2>
          <Typography align="right">
            <b>
              <Trans
                i18nKey="organizationSeatsSummary.seatsTaken"
                values={totals}
              />
            </b>
          </Typography>
        </Grid2>
      )}
    </Grid2>
  );
};
